<template>
  <div class="article-title" v-if="titleTxt!==''">
    <div class="article-title-txt">{{ titleTxt }}</div>
    <div class="article-title-task">
      {{ titleTask }}
      <i class="fa fa-chevron-right" aria-hidden="true"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArticleTitle',
  props: {
    titleTxt: {
      type: String,
      default: ''
    },
    titleTask: {
      type: String,
      default: '更多'
    }
  }
}
</script>

<style scoped lang="scss">
.article-title{
  height: 30px;
  background: #272D3B;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .article-title-txt{
    width: 184px;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #68829E;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .article-title-task{
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2992FF;
  }
}
</style>
